import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ToastViewport } from './components/toast-viewport.js';
import './lib/i18n.js';
import { queryClient } from './lib/query-client.js';
import { SessionProvider } from './lib/session.js';
import { ThemeProvider } from './lib/theme.js';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </ThemeProvider>
      <ToastViewport />
    </QueryClientProvider>
  </StrictMode>,
);
